export default "__VITE_ASSET__uamRwI3r__"